// import React, { useState, useRef, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { makeAuthenticatedRequest } from "../../utils/apiRequest";
// import { useAuth } from "../../contexts/authContext";
// import LoadingScreen from "./LoadingScreen"; // Import the LoadingScreen component


// const GenerateAIPage = () => {
//   // Add smooth scrolling to top when component mounts
  
//   const location = useLocation();
//   const { token, currentUser } = useAuth();
//   const navigate = useNavigate();

//   // Log the token to the console
//   console.log("Generate AI Token:", token);

//   const [inputText, setInputText] = useState("");
//   const [responseId, setResponseId] = useState(null);
//   const [error, setError] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
  
//   const [selectedCity, setSelectedCity] = useState([]); // Array of objects { day, city_name }

//   const [isOverlayVisible, setIsOverlayVisible] = useState(false);

//   const [cities, setCities] = useState([]);

//   const [isModalOpen, setIsModalOpen] = useState(false); // Control modal visibility
//   const [selectedDays, setSelectedDays] = useState(1); // Default to 1 day

//   const [hotels, setHotels] = useState([]);
//   const [suggestedHotels, setSuggestedHotels] = useState([]); // List of hotels for selected city
//   const [hoveredCity, setHoveredCity] = useState(null); // Track the hovered city name

//   const [cursorPosition, setCursorPosition] = useState(6); // Start after "Day 1: "
//   const [cityHotelsMap, setCityHotelsMap] = useState({});

//   const [restaurants, setRestaurants] = useState([]);

//   const [cityRestaurantsMap, setCityRestaurantsMap] = useState({});
//   const [suggestedRestaurants, setSuggestedRestaurants] = useState([]); // List of hotels for selected city

//   const [locations, setLocations] = useState([]); // To store fetched locations
//   const [searchLocation, setSearchLocation] = useState(""); // For search input
//   const [suggestedLocations, setSuggestedLocations] = useState([]); // Filtered list based on search

//   // New state for AI suggestions modal
//   const [showAISuggestions, setShowAISuggestions] = useState(false);
//   const [aiSuggestionType, setAiSuggestionType] = useState('locations'); // 'locations', 'hotels', 'restaurants'

//   // Add search states for AI suggestions
//   const [aiSearchTerm, setAiSearchTerm] = useState('');
//   const [filteredLocations, setFilteredLocations] = useState([]);
//   const [filteredHotels, setFilteredHotels] = useState([]);
//   const [filteredRestaurants, setFilteredRestaurants] = useState([]);
  

// // Handle opening the modal
// const openModal = () => {
//   setIsModalOpen(true);
// };

// // Handle closing the modal
// const closeModal = () => {
//   setIsModalOpen(false);
// };

// const removeCity = (cityName) => {
//   const updatedCities = selectedCity.filter((item) => item.city_name !== cityName);
//   setSelectedCity(updatedCities);

//   // Update the textarea with the remaining cities and days
//   const citiesWithDays = updatedCities.map((item, index) => `Day ${index + 1}: ${item.city_name}`).join('\n');
//   setInputText(citiesWithDays);
// };

//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   }, []);
  
//   // Add keyboard shortcuts
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       // Cmd/Ctrl + Enter to generate
//       if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
//         if (!isLoading && (inputText.trim() || selectedCity.length > 0)) {
//           handleGenerate();
//         }
//       }
//       // Escape to close modals
//       if (e.key === 'Escape') {
//         if (isModalOpen) closeModal();
//         if (showAISuggestions) setShowAISuggestions(false);
//       }
//     };

//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, [inputText, selectedCity, isLoading, isModalOpen, showAISuggestions]);

//   // Fetch cities when the component is mounted
//   useEffect(() => {
//     const fetchCitiesAndHotels = async () => {
//       if (!token) {
//         setError("Authorization token is missing.");
//         return;
//       }
  
//       setLoading(true);
//       setError(null);
  
//       try {
//         const citiesResponse = await makeAuthenticatedRequest(
//           "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_all_cities",
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
  
//         const citiesData = await citiesResponse.json();
//         setCities(citiesData.data || []);
  
//         // Fetch hotels
//         const hotelsResponse = await makeAuthenticatedRequest(
//           "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_hotel_data",
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
  
//         const hotelsData = await hotelsResponse.json();
//         setHotels(hotelsData.data || []);
  
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
  
//     fetchCitiesAndHotels();
//   }, [token]);

//   useEffect(() => { 
//     const fetchRestaurants = async () => {
//       if (!token) {
//         setError("Authorization token is missing.");
//         return;
//       }
  
//       setLoading(true);
//       setError(null);
  
//       try {
//         const response = await makeAuthenticatedRequest(
//           "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_meal_data",
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
  
//         if (!response.ok) {
//           const errorDetails = await response.json();
//           throw new Error(`Failed to fetch restaurant data: ${errorDetails.error}`);
//         }
  
//         const restaurantData = await response.json();
        
//         // Print the restaurantData to the console for debugging
//         console.log("Fetched restaurant data:", restaurantData);
  
//         // Extract the restaurant list from the `data` field
//         const restaurantList = restaurantData.data || [];
  
//         // Ensure we have an array to work with
//         if (Array.isArray(restaurantList)) {
//           setRestaurants(restaurantList);
//         } else {
//           setRestaurants([]); // Fallback to empty array if data format is incorrect
//           setError("Invalid restaurant data format.");
//         }
  
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
  
//     fetchRestaurants();
//   }, [token]);

//   // Initialize filtered arrays when data loads
//   useEffect(() => {
//     setFilteredLocations(locations);
//   }, [locations]);

//   useEffect(() => {
//     setFilteredHotels(hotels);
//   }, [hotels]);

//   useEffect(() => {
//     setFilteredRestaurants(restaurants);
//   }, [restaurants]);

//   // Handle search in AI suggestions
//   const handleAISearch = (searchTerm) => {
//     setAiSearchTerm(searchTerm);
    
//     if (searchTerm === '') {
//       // Reset to original data when search is empty
//       setFilteredLocations(locations);
//       setFilteredHotels(hotels);
//       setFilteredRestaurants(restaurants);
//     } else {
//       const lowerSearchTerm = searchTerm.toLowerCase();
      
//       // Filter locations
//       const filteredLocs = locations.filter(location =>
//         location.location_name.toLowerCase().includes(lowerSearchTerm)
//       );
//       setFilteredLocations(filteredLocs);
      
//       // Filter hotels (consider both hotel name and city)
//       const filteredHtls = hotels.filter(hotel =>
//         hotel.name.toLowerCase().includes(lowerSearchTerm) ||
//         hotel.city_name.toLowerCase().includes(lowerSearchTerm)
//       );
//       setFilteredHotels(filteredHtls);
      
//       // Filter restaurants (consider both restaurant name and city)
//       const filteredRests = restaurants.filter(restaurant =>
//         restaurant.resturant_name.toLowerCase().includes(lowerSearchTerm) ||
//         restaurant.city_name.toLowerCase().includes(lowerSearchTerm)
//       );
//       setFilteredRestaurants(filteredRests);
//     }
//   };

//   // Reset search when changing tabs
//   const handleTabChange = (newType) => {
//     setAiSuggestionType(newType);
//     setAiSearchTerm('');
//     // Reset filtered arrays
//     setFilteredLocations(locations);
//     setFilteredHotels(hotels);
//     setFilteredRestaurants(restaurants);
//   };
  
  
  
// const handleGenerate = async () => {
//     if (!inputText && selectedCity.length === 0) {
//       alert("Please type something or select cities to generate.");
//       return;
//     }
  
//     setIsLoading(true);
//     setError(null);
  
//     try {
//       const formattedInput = {
//         query1: inputText || "",
//         query2: selectedCity.map(item => `${item.city_name} `), // Convert the cities to string with day info
//       };
      
//       console.log("Request body sent to API:", JSON.stringify(formattedInput, null, 2));

//       console.log("Summery Using token:", token); // Added to print the token
  
//       const response = await makeAuthenticatedRequest(
//         "https://newquickmodel-v2-14140141147.us-central1.run.app",
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formattedInput),
//         }
//       );
  
//       if (!response.ok) {
//         const errorDetails = await response.json();
//         throw new Error(`Failed to generate AI response: ${errorDetails.error}`);
//       }
  
//       const result = await response.json();
//       const itineraryId = result.itinerary_id;
  
//       console.log("Generated Itinerary ID:", itineraryId);

//       console.log("Itinerary Data Using token:", token); // Added to print the token
  
//       const itineraryResponse = await makeAuthenticatedRequest(
//         "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_itinerary_data",
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ itinerary_id: itineraryId }),
//         }
//       );
  
//       if (!itineraryResponse.ok) {
//         const errorDetails = await itineraryResponse.json();
//         throw new Error(`Failed to fetch itinerary data: ${errorDetails.error}`);
//       }
  
//       const itineraryData = await itineraryResponse.json();
  
//       navigate("/home", {
//         state: {
//           token,
//           editData: itineraryData.data?.[0],
//         },
//       });
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };
// // Handle city selection by toggling chips

//   const handleCityToggle = (city) => {
//     const newCity = { day: selectedCity.length + 1, city_name: city };
  
//     // Fetch hotels for the selected city
//     const relevantHotels = hotels.filter(hotel => hotel.city_name === city);
  
//     // Fetch restaurants for the selected city
//     const relevantRestaurants = restaurants.filter(restaurant => restaurant.city_name === city);
  
//     // Update the cityHotelsMap and cityRestaurantsMap with the relevant data for that city
//     setCityHotelsMap((prevState) => ({
//       ...prevState,
//       [city]: relevantHotels,
//     }));
  
//     setCityRestaurantsMap((prevState) => ({
//       ...prevState,
//       [city]: relevantRestaurants,
//     }));
  
//     const updatedCities = [...selectedCity, newCity];
  
//     setSelectedCity(updatedCities);
  
//     // Preserve existing details in the textarea
//     let existingDetails = inputText.split("\n"); // Convert text area to an array
  
//     // Add new entry while keeping previous details
//     existingDetails.push(`Day ${updatedCities.length}: ${city}`);
  
//     setInputText(existingDetails.join("\n")); // Convert back to string
//   };
  
  
//   const handleCursorChange = (e) => {
//     const cursorPosition = e.target.selectionStart; // Get the current cursor position
//     const textBeforeCursor = inputText.slice(0, cursorPosition); // Text before the cursor
    
//     // Regular expression to find any city mentioned in the text (e.g., 'Day 1: Ella')
//     const cityRegex = /Day \d+: (\w+)/g;
//     const citiesInText = [];
//     let match;
    
//     // Extract all cities from the text using regex
//     while ((match = cityRegex.exec(textBeforeCursor)) !== null) {
//       citiesInText.push(match[1]); // match[1] will be the city name
//     }
    
//     // Get the most recent city (the one closest to the cursor)
//     const recentCity = citiesInText[citiesInText.length - 1];
    
//     // Set hoveredCity to recentCity
//     if (recentCity) {
//       setHoveredCity(recentCity);
  
//       // Get hotels and restaurants for the current city from the respective maps
//       const relevantHotels = cityHotelsMap[recentCity] || [];
//       const relevantRestaurants = cityRestaurantsMap[recentCity] || [];
  
//       setSuggestedHotels(relevantHotels); // Show hotel suggestions
//       setSuggestedRestaurants(relevantRestaurants); // Show restaurant suggestions
//     }
//   };
  
  
  
  
//   const insertHotelName = (hotelName) => {
//     const textBeforeCursor = inputText.slice(0, cursorPosition); // Text before the cursor
//     const textAfterCursor = inputText.slice(cursorPosition); // Text after the cursor
    
//     const newText = textBeforeCursor + ` - ${hotelName}` + textAfterCursor; // Insert hotel name at the cursor
//     setInputText(newText);
    
//     // Update cursor position to after the inserted hotel name
//     setCursorPosition(cursorPosition + hotelName.length + 3); // Adjust for "- " text
//     setShowAISuggestions(false); // Close AI suggestions modal
//   };
  

//   const insertRestaurantName = (restaurantName) => {
//     const textBeforeCursor = inputText.slice(0, cursorPosition); // Text before the cursor
//     const textAfterCursor = inputText.slice(cursorPosition); // Text after the cursor
    
//     const newText = textBeforeCursor + ` - ${restaurantName}` + textAfterCursor; // Insert restaurant name at the cursor
//     setInputText(newText);
    
//     // Update cursor position to after the inserted restaurant name
//     setCursorPosition(cursorPosition + restaurantName.length + 3); // Adjust for "- " text
//     setShowAISuggestions(false); // Close AI suggestions modal
//   };


//   useEffect(() => {
//     const fetchLocations = async () => {
//       if (!token) {
//         setError("Authorization token is missing.");
//         return;
//       }
  
//       setLoading(true);
//       setError(null);
  
//       try {
//         const response = await makeAuthenticatedRequest(
//           "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_location_data",
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
  
//         if (!response.ok) {
//           const errorDetails = await response.json();
//           throw new Error(`Failed to fetch location data: ${errorDetails.error}`);
//         }
  
//         const locationData = await response.json();
//         setLocations(locationData.data || []);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
  
//     fetchLocations();
//   }, [token]);

  
//   const handleLocationSearch = (searchTerm) => {
//     setSearchLocation(searchTerm);
//     if (searchTerm === "") {
//       setSuggestedLocations([]); // Clear suggestions when search is empty
//     } else {
//       const filteredLocations = locations.filter(location =>
//         location.location_name.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setSuggestedLocations(filteredLocations);
//     }
//   };

//   const handleLocationSelect = (locationName) => {
//     // Get the text before the cursor, the text after the cursor, and insert the location
//     const textBeforeCursor = inputText.slice(0, cursorPosition); // Text before the cursor
//     const textAfterCursor = inputText.slice(cursorPosition); // Text after the cursor
  
//     // Insert the location name at the cursor
//     const newText = textBeforeCursor + ` ${locationName}` + textAfterCursor;
    
//     // Update the input text with the new value
//     setInputText(newText);
    
//     // Update the cursor position to after the inserted location name
//     setCursorPosition(cursorPosition + locationName.length + 1); // Add 1 for the space after the location name
    
//     // Clear the search and suggestions after selecting a location
//     setSearchLocation(""); // Optionally clear the search field
//     setSuggestedLocations([]); // Clear the location suggestions
//     setShowAISuggestions(false); // Close AI suggestions modal
//   };

//   // Handle AI icon click
//   const handleAIIconClick = () => {
//     setShowAISuggestions(true);
//     setAiSuggestionType('locations'); // Default to locations
//     setAiSearchTerm(''); // Clear search when opening
//   };

//   // Handle clearing the input field
//   const handleClearInput = () => {
//     setInputText("");
//     setCursorPosition(0);
//     setHoveredCity(null);
//     setSuggestedHotels([]);
//     setSuggestedRestaurants([]);
//   };

//   // Get filtered suggestions based on current city context and search
//   const getFilteredSuggestions = () => {
//     if (aiSuggestionType === 'hotels') {
//       if (hoveredCity && cityHotelsMap[hoveredCity]) {
//         // Filter city-specific hotels based on search
//         if (aiSearchTerm) {
//           return cityHotelsMap[hoveredCity].filter(hotel =>
//             hotel.name.toLowerCase().includes(aiSearchTerm.toLowerCase())
//           );
//         }
//         return cityHotelsMap[hoveredCity];
//       }
//       return filteredHotels;
//     } else if (aiSuggestionType === 'restaurants') {
//       if (hoveredCity && cityRestaurantsMap[hoveredCity]) {
//         // Filter city-specific restaurants based on search
//         if (aiSearchTerm) {
//           return cityRestaurantsMap[hoveredCity].filter(restaurant =>
//             restaurant.resturant_name.toLowerCase().includes(aiSearchTerm.toLowerCase())
//           );
//         }
//         return cityRestaurantsMap[hoveredCity];
//       }
//       return filteredRestaurants;
//     } else {
//       return filteredLocations;
//     }
//   };

//   // Show the custom LoadingScreen component when isLoading is true
//   if (isLoading) {
//     return <LoadingScreen />;
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-900 dark:to-gray-800 py-12 px-4 sm:px-6 lg:px-8 transition-colors duration-200">
//       <div className="max-w-5xl mx-auto">
//         <div className="text-center mb-12">
//           <h1 className="text-4xl font-bold text-gray-900 dark:text-white sm:text-5xl bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600 dark:from-blue-400 dark:to-indigo-400">
//             Plan Your Perfect Trip
//           </h1>
//           <p className="mt-4 text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
//             Create a personalized itinerary with our AI assistant and craft your dream vacation
//           </p>
//         </div>

//         <div className="max-w-3xl mx-auto mb-8 bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl">
//           <button
//             onClick={openModal}
//             className="w-full flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
//           >
//             <svg className="w-6 h-6 mr-3 text-blue-100" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//             </svg>
//             <span className="text-lg">Select Your Destinations</span>
//           </button>
//         </div>

//         <div className="mb-8 animate-fade-in">
//           {selectedCity.length > 0 && (
//             <div className="mb-4">
//               <h3 className="text-sm font-semibold text-gray-600 dark:text-gray-300 mb-3 uppercase tracking-wider">Your Selected Destinations</h3>
//               <div className="flex flex-wrap gap-3">
//                 {Array.from(new Set(selectedCity.map(city => city.city_name))).map((cityName, index) => (
//                   <div
//                     key={index}
//                     className="inline-flex items-center bg-white dark:bg-gray-700 text-blue-700 dark:text-blue-300 rounded-full px-5 py-2.5 text-sm font-medium shadow-md border border-blue-100 dark:border-gray-600 hover:shadow-lg transition-all duration-200 transform hover:-translate-y-0.5"
//                   >
//                     <svg className="w-4 h-4 mr-2 text-blue-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
//                       <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
//                     </svg>
//                     {cityName}
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         removeCity(cityName);
//                       }}
//                       className="ml-2 text-gray-400 hover:text-red-500 dark:hover:text-red-400 focus:outline-none transition-colors duration-200 p-1 -mr-2"
//                       aria-label={`Remove ${cityName}`}
//                     >
//                       <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                       </svg>
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Small Popup for city selection using chips */}
//         {isModalOpen && (
//           <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
//             <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
//               <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={closeModal}></div>
//               <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
//               <div className="inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
//                 <div className="bg-white dark:bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
//                   <div className="sm:flex sm:items-start">
//                     <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
//                       <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white mb-4" id="modal-title">
//                         Select Your Destinations
//                       </h3>
//                       <div className="mt-2 relative">
//                         <input
//                           type="text"
//                           className="block w-full px-4 py-2 text-gray-900 dark:text-white bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm mb-4"
//                           placeholder="Search cities..."
//                           onChange={(e) => {
//                             const searchTerm = e.target.value.toLowerCase();
//                             const filtered = cities.filter(city => 
//                               city.city_name.toLowerCase().includes(searchTerm)
//                             );
//                             setCities(filtered);
//                           }}
//                         />
//                         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 max-h-[60vh] overflow-y-auto p-1">
//                           {cities.map((city) => (
//                             <div
//                               key={city.city_id}
//                               onClick={() => handleCityToggle(city.city_name)}
//                               className={`flex items-center p-3 rounded-lg border cursor-pointer transition-colors ${
//                                 selectedCity.some(c => c.city_name === city.city_name)
//                                   ? 'bg-blue-50 dark:bg-blue-900 border-blue-200 dark:border-blue-700'
//                                   : 'bg-white dark:bg-gray-700 border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600'
//                               }`}
//                             >
//                               <div className={`flex-shrink-0 h-5 w-5 rounded-full border flex items-center justify-center mr-3 ${
//                                 selectedCity.some(c => c.city_name === city.city_name)
//                                   ? 'bg-blue-500 border-blue-500 text-white'
//                                   : 'border-gray-300 dark:border-gray-500'
//                               }`}>
//                                 {selectedCity.some(c => c.city_name === city.city_name) && (
//                                   <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
//                                     <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
//                                   </svg>
//                                 )}
//                               </div>
//                               <span className="text-sm font-medium text-gray-900 dark:text-white">
//                                 {city.city_name}
//                               </span>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="bg-gray-50 dark:bg-gray-800 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-b-lg">
//                   <button
//                     type="button"
//                     onClick={closeModal}
//                     className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm transition-colors"
//                   >
//                     Done
//                   </button>
//                   <button
//                     type="button"
//                     onClick={() => {
//                       setSelectedCity([]);
//                       setInputText("Day 1: ");
//                     }}
//                     className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-2 bg-white dark:bg-gray-700 text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm transition-colors"
//                   >
//                     Clear All
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl">
//           <div className="px-8 py-6 border-b border-gray-100 dark:border-gray-700 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-900">
//             <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
//               <div className="mb-4 sm:mb-0">
//                 <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Itinerary Builder</h3>
//                 <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Build your perfect travel plan</p>
//               </div>
//               <div className="flex space-x-3">
//                 <button
//                   onClick={handleAIIconClick}
//                   className="inline-flex items-center px-4 py-2.5 border border-transparent text-sm font-medium rounded-lg text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-md hover:shadow-lg"
//                   title="AI Suggestions"
//                 >
//                   <svg className="w-5 h-5 mr-2 text-blue-100" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                   </svg>
//                   AI Assistant
//                 </button>
//               </div>
//             </div>
//           </div>
          
//           <div className="p-6">
//             <div className="relative group">
//               <label htmlFor="itinerary-input" className="sr-only">Plan your itinerary</label>
//               <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-xl blur opacity-10 group-hover:opacity-20 transition duration-1000 group-hover:duration-200"></div>
//               <textarea
//                 id="itinerary-input"
//                 value={inputText}
//                 onChange={(e) => {
//                   setInputText(e.target.value);
//                   setCursorPosition(e.target.selectionStart);
//                   handleCursorChange(e);
//                 }}
//                 onClick={(e) => setCursorPosition(e.target.selectionStart)}
//                 placeholder="Start by typing 'Day 1: [City Name]' or click 'AI Assistant' for suggestions..."
//                 className="relative block w-full px-6 py-5 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent sm:text-base resize-y min-h-[220px] transition-all duration-200 focus:outline-none focus:shadow-lg"
//                 rows={8}
//               />
//               <div className="absolute bottom-4 right-4 flex items-center space-x-2">
//                 {inputText && (
//                   <button
//                     onClick={handleClearInput}
//                     className="p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
//                     title="Clear input"
//                   >
//                     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
//                     </svg>
//                   </button>
//                 )}
//                 <div className="text-xs text-gray-400 dark:text-gray-500 px-2 py-1 bg-gray-50 dark:bg-gray-800 rounded-full">
//                   {inputText.length} characters
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* AI Suggestions Modal with Search */}
//           {showAISuggestions && (
//             <div className="fixed inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
//               <div className="bg-white dark:bg-zinc-900 p-6 rounded-2xl shadow-2xl max-w-4xl w-full max-h-[80vh] flex flex-col border border-blue-200 dark:border-zinc-800">
//                 <div className="flex justify-between items-center mb-4">
//                   <h2 className="text-lg font-bold text-gray-900 dark:text-white">AI Suggestions</h2>
//                   <button
//                     onClick={() => setShowAISuggestions(false)}
//                     className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 text-2xl"
//                   >
//                     ✖
//                   </button>
//                 </div>
                
//                 {/* Tab buttons */}
//                 <div className="flex gap-2 mb-4 border-b border-gray-200 dark:border-gray-700">
//                   <button
//                     onClick={() => handleTabChange('locations')}
//                     className={`px-4 py-2 rounded-t-lg transition-colors ${
//                       aiSuggestionType === 'locations' 
//                         ? 'bg-blue-500 text-white' 
//                         : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
//                     }`}
//                   >
//                     Locations
//                   </button>
//                   <button
//                     onClick={() => handleTabChange('hotels')}
//                     className={`px-4 py-2 rounded-t-lg transition-colors ${
//                       aiSuggestionType === 'hotels' 
//                         ? 'bg-blue-500 text-white' 
//                         : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
//                     }`}
//                   >
//                     Hotels {hoveredCity && `(${hoveredCity})`}
//                   </button>
//                   <button
//                     onClick={() => handleTabChange('restaurants')}
//                     className={`px-4 py-2 rounded-t-lg transition-colors ${
//                       aiSuggestionType === 'restaurants' 
//                         ? 'bg-blue-500 text-white' 
//                         : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
//                     }`}
//                   >
//                     Restaurants {hoveredCity && `(${hoveredCity})`}
//                   </button>
//                 </div>

//                 {/* Search Bar */}
//                 <div className="mb-4">
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                       </svg>
//                     </div>
//                     <input
//                       type="text"
//                       value={aiSearchTerm}
//                       onChange={(e) => handleAISearch(e.target.value)}
//                       className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md leading-5 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
//                       placeholder={`Search ${aiSuggestionType}...`}
//                     />
//                     {aiSearchTerm && (
//                       <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
//                         <button
//                           onClick={() => handleAISearch('')}
//                           className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
//                         >
//                           <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                           </svg>
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 </div>
                
//                 {/* Suggestions content */}
//                 <div className="flex-1 overflow-auto">
//                   {aiSuggestionType === 'locations' && (
//                     <div className="grid grid-cols-3 gap-2">
//                       {getFilteredSuggestions().map((location) => (
//                         <div
//                           key={location.location_id}
//                           onClick={() => handleLocationSelect(location.location_name)}
//                           className="cursor-pointer p-3 border border-gray-200 dark:border-gray-600 rounded hover:bg-blue-50 dark:hover:bg-blue-900 hover:border-blue-300 dark:hover:border-blue-500 transition-colors"
//                         >
//                           <div className="text-sm font-medium text-gray-900 dark:text-white">
//                             {location.location_name}
//                           </div>
//                         </div>
//                       ))}
//                       {getFilteredSuggestions().length === 0 && (
//                         <p className="col-span-3 text-center text-gray-500 dark:text-gray-400 py-4">
//                           No locations found
//                         </p>
//                       )}
//                     </div>
//                   )}
                  
//                   {aiSuggestionType === 'hotels' && (
//                     <div className="grid grid-cols-2 gap-2">
//                       {getFilteredSuggestions().map((hotel) => (
//                         <div
//                           key={hotel.hotel_id}
//                           onClick={() => insertHotelName(hotel.name)}
//                           className="cursor-pointer p-3 border border-gray-200 dark:border-gray-600 rounded hover:bg-blue-50 dark:hover:bg-blue-900 hover:border-blue-300 dark:hover:border-blue-500 transition-colors"
//                         >
//                           <div className="font-semibold text-gray-900 dark:text-white">{hotel.name}</div>
//                           <div className="text-sm text-gray-500 dark:text-gray-400">{hotel.city_name}</div>
//                         </div>
//                       ))}
//                       {getFilteredSuggestions().length === 0 && (
//                         <p className="col-span-2 text-center text-gray-500 dark:text-gray-400 py-4">
//                           No hotels found
//                         </p>
//                       )}
//                     </div>
//                   )}
                  
//                   {aiSuggestionType === 'restaurants' && (
//                     <div className="grid grid-cols-2 gap-2">
//                       {getFilteredSuggestions().map((restaurant) => (
//                         <div
//                           key={restaurant.meal_id}
//                           onClick={() => insertRestaurantName(restaurant.resturant_name)}
//                           className="cursor-pointer p-3 border border-gray-200 dark:border-gray-600 rounded hover:bg-blue-50 dark:hover:bg-blue-900 hover:border-blue-300 dark:hover:border-blue-500 transition-colors"
//                         >
//                           <div className="font-semibold text-gray-900 dark:text-white">{restaurant.resturant_name}</div>
//                           <div className="text-sm text-gray-500 dark:text-gray-400">{restaurant.city_name}</div>
//                         </div>
//                       ))}
//                       {getFilteredSuggestions().length === 0 && (
//                         <p className="col-span-2 text-center text-gray-500 dark:text-gray-400 py-4">
//                           No restaurants found
//                         </p>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}

//           <div className="px-6 pb-8 text-center">
//             <button
//               onClick={handleGenerate}
//               disabled={isLoading || (!inputText.trim() && selectedCity.length === 0)}
//               className={`relative inline-flex items-center px-10 py-4 text-lg font-semibold rounded-xl shadow-lg transform transition-all duration-300 ${
//                 isLoading || (!inputText.trim() && selectedCity.length === 0)
//                   ? 'bg-gray-300 dark:bg-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed'
//                   : 'text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 hover:shadow-xl hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'
//               } overflow-hidden group`}
//             >
//               <span className="absolute inset-0 w-full h-full transition duration-300 ease-out transform -translate-x-full bg-white/30 group-hover:translate-x-0"></span>
//               <span className="relative flex items-center">
//                 {isLoading ? (
//                   <>
//                     <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                       <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                       <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                     </svg>
//                     Crafting Your Itinerary...
//                   </>
//                 ) : (
//                   <>
//                     <svg className="w-5 h-5 mr-2 text-blue-100" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                     </svg>
//                     Generate My Itinerary
//                   </>
//                 )}
//               </span>
//             </button>
//             <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
//               {/* Press <kbd className="px-2 py-1 bg-gray-100 dark:bg-gray-700 rounded-md text-xs font-mono">Ctrl + Enter</kbd> to generate */}
//             </p>
//           </div>
//           {responseId && <p className="text-green-500">Generated Itinerary ID: {responseId}</p>}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default GenerateAIPage;


import LoadingScreen from "./LoadingScreen";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { makeAuthenticatedRequest } from "../../utils/apiRequest";
import { useAuth } from "../../contexts/authContext";
import { useEffect } from "react";

const GenerateAIPage = () => {
  const location = useLocation();
  const { token, currentUser } = useAuth();
  const navigate = useNavigate();

  // Log the token to the console
  console.log("Generate AI Token:", token);

  const [inputText, setInputText] = useState("");
  const [responseId, setResponseId] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCity, setSelectedCity] = useState([]); // Ensure it's an array

  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const [cities, setCities] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false); // Control modal visibility
  const [selectedDays, setSelectedDays] = useState(1); // Default to 1 day

  const [searchQuery, setSearchQuery] = useState(""); // State to store the search query

// Handle opening the modal
const openModal = () => {
  setIsModalOpen(true);
};

// Handle closing the modal
const closeModal = () => {
  setIsModalOpen(false);
};

// Handle removing city from selected list
const removeCity = (city) => {
  setSelectedCity(selectedCity.filter((c) => c !== city));
};
  
  const [loading, setLoading] = useState(false);

  // Fetch cities when the component is mounted
  useEffect(() => {
    const fetchCities = async () => {
      if (!token) {
        setError("Authorization token is missing.");
        return;
      }

      console.log("City Using token:", token); // Added to print the token

      setLoading(true);
      setError(null);

      try {
        const response = await makeAuthenticatedRequest(
          "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_all_cities",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch cities. Status: ${response.status}`);
        }

        const data = await response.json();
        setCities(data.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCities();
  }, [token]);

  const handleGenerate = async () => {
    if (!inputText && selectedCity.length === 0) {
      alert("Please type something or select cities to generate.");
      return;
    }
  
    setIsLoading(true);
    setError(null);
  
    try {
      const formattedInput = {
        query1: inputText || "",
        query2: selectedCity.length > 0 ? selectedCity : [],
        // query3: selectedDays,
      };
  
      console.log("Request body sent to API:", JSON.stringify(formattedInput, null, 2));

      console.log("Summery Using token:", token); // Added to print the token
  
      const response = await makeAuthenticatedRequest(
        "https://quickmodel-flash-14140141147.us-central1.run.app",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formattedInput),
        }
      );
  
      if (!response.ok) {
        const errorDetails = await response.json();
        throw new Error(`Failed to generate AI response: ${errorDetails.error}`);
      }
  
      const result = await response.json();
      console.log("AI Generation Full Response:", JSON.stringify(result, null, 2));
      const itineraryId = result.itinerary_id;
  
      console.log("Generated Itinerary ID:", itineraryId);

      console.log("Itinerary Data Using token:", token); // Added to print the token

      console.log("result:", result);
  
      const itineraryResponse = await makeAuthenticatedRequest(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_itinerary_data",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ itinerary_id: itineraryId }),
        }
      );
  
      if (!itineraryResponse.ok) {
        const errorDetails = await itineraryResponse.json();
        throw new Error(`Failed to fetch itinerary data: ${errorDetails.error}`);
      }
  
      const itineraryData = await itineraryResponse.json();

      console.log("Itinerary Data :", itineraryData); 
  
      navigate("/home", {
        state: {
          token,
          editData: itineraryData.data?.[0],
        },
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };
  
  // Handle city selection by toggling chips
  const handleCityToggle = (city) => {
    if (selectedCity.includes(city)) {
      // Remove city if already selected
      setSelectedCity(selectedCity.filter((c) => c !== city));
    } else {
      // Add city to selected list
      setSelectedCity([...selectedCity, city]);
    }
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-blue-50 via-white to-blue-100 relative overflow-y-auto">
      {/* Enhanced Custom Styles */}
      <style>{`
        .glass-morphism {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(59, 130, 246, 0.2);
          box-shadow: 
            0 20px 25px -5px rgba(0, 0, 0, 0.1),
            0 10px 10px -5px rgba(0, 0, 0, 0.04),
            0 0 0 1px rgba(59, 130, 246, 0.05);
        }
        
        .btn-primary {
          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
          box-shadow: 
            0 4px 14px 0 rgba(59, 130, 246, 0.3),
            inset 0 1px 0 0 rgba(255, 255, 255, 0.2);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .btn-primary:hover {
          background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
          box-shadow: 
            0 6px 20px 0 rgba(59, 130, 246, 0.4),
            inset 0 1px 0 0 rgba(255, 255, 255, 0.2);
          transform: translateY(-1px);
        }
        
        .btn-primary:active {
          transform: translateY(0);
          box-shadow: 
            0 2px 8px 0 rgba(59, 130, 246, 0.3),
            inset 0 1px 0 0 rgba(255, 255, 255, 0.2);
        }
        
        .input-field {
          background: rgba(255, 255, 255, 0.9);
          border: 2px solid rgba(59, 130, 246, 0.2);
          transition: all 0.3s ease;
        }
        
        .input-field:focus {
          background: rgba(255, 255, 255, 1);
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }
        
        .chip {
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
          transition: all 0.2s ease;
        }
        
        .chip:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
        }
        
        .modal-backdrop {
          background: rgba(0, 0, 0, 0.5);
          backdrop-filter: blur(8px);
        }
        
        .city-card {
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          border: 2px solid transparent;
        }
        
        .city-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px -8px rgba(59, 130, 246, 0.3);
          border-color: rgba(59, 130, 246, 0.3);
        }
        
        .city-card.selected {
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          color: white;
          border-color: #1d4ed8;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px -8px rgba(59, 130, 246, 0.5);
        }
        
        .floating-elements::before {
          content: '';
          position: absolute;
          top: 10%;
          left: 5%;
          width: 60px;
          height: 60px;
          background: radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, transparent 70%);
          border-radius: 50%;
          animation: float 6s ease-in-out infinite;
        }
        
        .floating-elements::after {
          content: '';
          position: absolute;
          top: 60%;
          right: 8%;
          width: 50px;
          height: 50px;
          background: radial-gradient(circle, rgba(59, 130, 246, 0.08) 0%, transparent 70%);
          border-radius: 50%;
          animation: float 8s ease-in-out infinite reverse;
        }

        @media (min-width: 768px) {
          .floating-elements::before {
            width: 100px;
            height: 100px;
          }
          
          .floating-elements::after {
            width: 80px;
            height: 80px;
          }
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(10deg); }
        }
        
        .animate-fade-in {
          animation: fadeIn 0.6s ease-out;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-scale-in {
          animation: scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        
        @keyframes scaleIn {
          from { opacity: 0; transform: scale(0.8); }
          to { opacity: 1; transform: scale(1); }
        }
        
        .loading-spinner {
          animation: spin 1s linear infinite;
        }
        
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        /* Mobile optimizations */
        @media (max-width: 640px) {
          .glass-morphism {
            backdrop-filter: blur(15px);
          }
          
          .modal-backdrop {
            backdrop-filter: blur(5px);
          }
        }
      `}</style>

      {/* Floating Background Elements */}
      <div className="floating-elements absolute inset-0 pointer-events-none" />

      {/* Header Section */}
      <div className="relative z-10 px-3 sm:px-4 lg:px-8 py-4 sm:py-6">
        {/* Back Button */}
        <button
          onClick={() => navigate("/user", { state: { token } })}
          className="fixed top-3 left-3 sm:top-4 sm:left-4 lg:top-6 lg:left-6 z-50 glass-morphism rounded-full p-2 sm:p-3 hover:shadow-lg transition-all duration-300 group"
          title="Go Back"
          aria-label="Go Back"
        >
          <svg 
            className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-blue-600 group-hover:text-blue-700 transition-colors" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        {/* Main Container */}
        <div className="max-w-xs sm:max-w-lg md:max-w-2xl lg:max-w-4xl xl:max-w-5xl mx-auto pt-4 sm:pt-6 lg:pt-8">
          {/* Header */}
          <div className="text-center mb-6 sm:mb-8 lg:mb-12 animate-fade-in px-2">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Generate AI
              <span className="block text-blue-600">Travel Itinerary</span>
            </h1>
            <div className="w-12 sm:w-16 lg:w-24 h-1 bg-gradient-to-r from-blue-500 to-blue-600 mx-auto mb-3 sm:mb-4 rounded-full" />
            {/* <p className="text-sm sm:text-base lg:text-lg text-gray-600 max-w-xs sm:max-w-lg lg:max-w-2xl mx-auto px-2 sm:px-4">
              Plan your perfect trip in seconds with AI-powered recommendations. Select your destinations and describe your preferences.
            </p> */}
          </div>

          {/* Main Card */}
          <div className="glass-morphism rounded-xl sm:rounded-2xl lg:rounded-3xl p-4 sm:p-6 lg:p-8 xl:p-10 animate-scale-in mx-2 sm:mx-0">
            
            {/* Selected Cities Display */}
            {selectedCity.length > 0 && (
              <div className="mb-4 sm:mb-5 lg:mb-6">
                <h3 className="text-xs sm:text-sm font-semibold text-gray-700 mb-2 sm:mb-3 uppercase tracking-wide">Selected Destinations</h3>
                <div className="flex flex-wrap gap-1.5 sm:gap-2 lg:gap-3">
                  {selectedCity.map((city, idx) => (
                    <div
                      key={idx}
                      className="chip text-white rounded-full px-2.5 sm:px-3 lg:px-4 py-1.5 sm:py-2 flex items-center gap-1.5 sm:gap-2 animate-fade-in text-xs sm:text-sm lg:text-base"
                      style={{ animationDelay: `${idx * 100}ms` }}
                    >
                      <span className="font-medium">{city}</span>
                      <button
                        className="ml-0.5 sm:ml-1 w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 bg-white/20 hover:bg-red-500 rounded-full flex items-center justify-center transition-all duration-200 text-xs font-bold"
                        onClick={() => removeCity(city)}
                        aria-label={`Remove ${city}`}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* City Selection Button */}
            <div className="mb-4 sm:mb-5 lg:mb-6">
              <button
                onClick={openModal}
                className="w-full sm:max-w-xs btn-primary text-white font-semibold py-3 sm:py-3.5 lg:py-3.5 px-4 sm:px-6 rounded-lg sm:rounded-xl lg:rounded-xl transition-all duration-300 text-sm sm:text-base"
                disabled={isLoading}
              >
                <span className="flex items-center justify-center gap-1.5 sm:gap-2">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Select Cities
                </span>
              </button>
            </div>

            {/* Input Section */}
            <div className="mb-4 sm:mb-5 lg:mb-6">
              <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2 sm:mb-3 uppercase tracking-wide">
                Describe Your Trip Preferences
              </label>
              <textarea
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                placeholder={`e.g., "Day 1 – Colombo (arrival)
- Visit Galle Face, Gangaramaya Temple, and Colombo Zoo
- Stay at Amari Hotel on B&B basis

Day 2 – Kandy  
- Visit Pinnawala Elephant Orphanage
- Stay at Cinnamon Citadel on H&B basis

Day 3 – Dambulla (departure)
- Visit Panduwasnuwara before departure

Starting from 7th July 2025"`}
                className="input-field w-full min-h-[100px] sm:min-h-[110px] lg:min-h-[120px] rounded-lg sm:rounded-xl lg:rounded-xl p-3 sm:p-4 lg:p-4 resize-y focus:outline-none text-sm sm:text-base leading-relaxed"
                rows={4}
                disabled={isLoading}
              />
            </div>

            {/* Generate Button */}
            <div className="mb-4">
              <button
                onClick={handleGenerate}
                className="w-full btn-primary text-white font-bold py-3.5 sm:py-4 lg:py-4 px-4 sm:px-6 rounded-lg sm:rounded-xl lg:rounded-xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base lg:text-base"
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="flex items-center justify-center gap-2 sm:gap-3">
                    <div className="loading-spinner w-4 h-4 sm:w-5 sm:h-5 lg:w-5 lg:h-5 border-2 border-white border-t-transparent rounded-full" />
                    <span className="hidden sm:inline">Generating Your Itinerary...</span>
                    <span className="sm:hidden">Generating...</span>
                  </span>
                ) : (
                  <span className="flex items-center justify-center gap-1.5 sm:gap-2">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 lg:w-5 lg:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    Generate AI Itinerary
                  </span>
                )}
              </button>
            </div>

            {/* Error Message */}
            {error && (
              <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-red-50 border border-red-200 rounded-lg sm:rounded-xl animate-fade-in">
                <p className="text-red-700 font-medium text-xs sm:text-sm lg:text-base text-center">
                  ❌ Error: {error}
                </p>
              </div>
            )}

            {/* Success Message */}
            {responseId && (
              <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-blue-50 border border-blue-200 rounded-lg sm:rounded-xl animate-fade-in">
                <p className="text-blue-700 font-semibold text-xs sm:text-sm lg:text-base text-center break-all">
                  ✅ Generated Itinerary ID: {responseId}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* City Selection Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 modal-backdrop">
          <div className="glass-morphism rounded-xl sm:rounded-2xl lg:rounded-3xl w-full max-w-sm sm:max-w-lg lg:max-w-2xl max-h-[85vh] sm:max-h-[90vh] flex flex-col animate-scale-in">
            
            {/* Modal Header */}
            <div className="flex items-center justify-between p-3 sm:p-4 lg:p-6 border-b border-blue-100">
              <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900">Select Cities</h2>
              <button
                onClick={closeModal}
                className="w-7 h-7 sm:w-8 sm:h-8 lg:w-10 lg:h-10 flex items-center justify-center rounded-full hover:bg-blue-50 transition-colors text-gray-500 hover:text-gray-700"
                aria-label="Close modal"
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Search Input */}
            <div className="p-3 sm:p-4 lg:p-6 border-b border-blue-100">
              <div className="relative">
                <svg className="absolute left-2.5 sm:left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search cities..."
                  className="input-field w-full pl-8 sm:pl-10 pr-3 sm:pr-4 py-2.5 sm:py-3 lg:py-4 rounded-lg sm:rounded-xl focus:outline-none text-sm sm:text-base"
                  autoFocus
                />
              </div>
            </div>

            {/* Cities Grid */}
            <div className="flex-1 overflow-y-auto p-3 sm:p-4 lg:p-6">
              {loading ? (
                <div className="flex items-center justify-center py-8 sm:py-12">
                  <div className="loading-spinner w-6 h-6 sm:w-8 sm:h-8 border-2 sm:border-3 border-blue-500 border-t-transparent rounded-full" />
                </div>
              ) : (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-1.5 sm:gap-2 lg:gap-3">
                  {cities
                    .filter((city) => city.city_name.toLowerCase().includes(searchQuery.toLowerCase()))
                    .map((city) => (
                      <button
                        key={city.city_id}
                        className={`city-card p-2 sm:p-3 lg:p-4 rounded-md sm:rounded-lg lg:rounded-xl text-center font-medium text-xs sm:text-sm lg:text-base ${
                          selectedCity.includes(city.city_name)
                            ? 'selected'
                            : 'bg-white text-gray-700 hover:bg-blue-50'
                        }`}
                        onClick={() => handleCityToggle(city.city_name)}
                      >
                        <span className="break-words">{city.city_name}</span>
                      </button>
                    ))}
                </div>
              )}
            </div>

            {/* Modal Footer */}
            <div className="p-3 sm:p-4 lg:p-6 border-t border-blue-100">
              <button
                onClick={closeModal}
                className="w-full btn-primary text-white font-semibold py-2.5 sm:py-3 lg:py-4 px-4 sm:px-6 rounded-lg sm:rounded-xl transition-all duration-300 text-sm sm:text-base"
              >
                Done ({selectedCity.length} selected)
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading Screen Overlay */}
      {isLoading && <LoadingScreen />}
    </div>
  );
};

export default GenerateAIPage;